export default __webpack_public_path__ + "static/media/ThreePhaseImg.7908014d.jpg";